import { useQuery } from '@tanstack/react-query';
import { listQueryDefaults } from '../../../lib/query/listQuery';
import { getCommissions } from '../api/commissions';
import type { GetCommissionsParams } from '../types';

export function useCommissions(params: GetCommissionsParams | null) {
  return useQuery({
    queryKey: ['commissions', params],
    queryFn: () => getCommissions(params!),
    enabled:
      params !== null &&
      params.dateFrom !== '' &&
      params.dateTo !== '',
    ...listQueryDefaults,
  });
}
